/**
 * useSwitchOrg — cambia la organización activa de la sesión.
 *
 * Llama POST /auth/switch-org, guarda el nuevo access token en memoria
 * (la cookie taxor_refresh la rota el servidor en el mismo response) y
 * limpia el cache de TanStack Query para que los siguientes requests
 * usen la org nueva.
 */

import { useQueryClient } from '@tanstack/react-query'
import { authApi, setAccessToken } from '@/lib/api'

export function useSwitchOrg() {
  const qc = useQueryClient()
  return async (organization_id: string) => {
    const resp = await authApi.switchOrg(organization_id)
    setAccessToken(resp.access_token)
    // Cache reset — los datos del dashboard probablemente filtran por
    // active_org. Forzamos refetch desde cero. Mantenemos /auth/me
    // específicamente para que el header refresque inmediatamente.
    qc.clear()
    return resp
  }
}
